import _extends from "@babel/runtime/helpers/extends";
//Documentation: https://developer.genesys.cloud/commdigital/digital/webchat/
import React, { useEffect, useState } from "react";
import { Input, Button } from "../..";
import { useForm } from "@mantine/form";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var orgGuid = process.env.NEXT_PUBLIC_PURE_CLOUD_ORG_ID || '';
var deploymentId = process.env.NEXT_PUBLIC_PURE_CLOUD_DEPLOYMENT_ID || '';
var chatConfig = {
  webchatAppUrl: "https://apps.mypurecloud.com/webchat",
  webchatServiceUrl: "https://realtime.mypurecloud.com:443",
  orgGuid,
  orgId: 9985,
  priority: 5,
  skills: [],
  orgName: "n7005695rcancercouncilqld",
  queueName: process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ? "13 11 20 Webchat" : "Training Queue",
  showSubmitButton: true,
  reconnectEnabled: true,
  reconnectOrigins: ["https://cancerqld.org.au/"],
  logLevel: "DEBUG",
  locale: "en",
  onlineSchedules: [{
    day: "Monday-Friday",
    time: "0800-1800",
    city: "Australia/Melbourne"
  }],
  chatNowElement: "chatForm",
  companyLogoSmall: {
    width: 149,
    height: 78,
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Solid_white.svg/2000px-Solid_white.svg.png"
  },
  agentAvatar: {
    width: 462,
    height: 462,
    url: "https://dhqbrvplips7x.cloudfront.net/webchat/1.0.23/agent-e202505f.png"
  },
  welcomeMessage: "Thank you for contacting Cancer Council Queensland. Please wait while we connect you with a Cancer Support Advisor...",
  css: {
    width: "100%",
    height: "100%",
    minHeight: "400px"
  },
  offlineSchedules: [{
    day: "Monday-Sunday",
    time: "1400-2359",
    city: "Australia/Brisbane"
  }, {
    day: "Monday-Sunday",
    time: "0000-0959",
    city: "Australia/Brisbane"
  }, {
    date: 25,
    month: 12,
    year: 2018,
    city: "Australia/Brisbane"
  }]
};

var appendScript = script => {
  if (document.head.querySelector("[src=\"" + script.src + "\"]")) return;
  var scriptElement = document.createElement("script");

  for (var [_key, value] of Object.entries(script)) {
    scriptElement.setAttribute(_key, value);
  }

  document.head.appendChild(scriptElement);
};

export var PurecloudChat = () => {
  var [webchat, setWebchat] = useState(null);
  var [hideForm, setHideForm] = useState(false);
  var form = useForm({
    initialValues: {
      firstName: "",
      lastName: "",
      email: ""
    },
    validate: {
      firstName: value => /\w/.test(value) ? null : "This field is required.",
      lastName: value => /\w/.test(value) ? null : "This field is required.",
      email: value => /^\S+@\S+$/.test(value) ? null : "This must be a valid email."
    }
  });

  var startChat = e => {
    e.preventDefault();
    form.validate();
    if (!webchat || !form.isValid()) return;
    var {
      firstName,
      lastName,
      email
    } = form.values;

    try {
      webchat.getConfig().setData({
        firstName,
        lastName,
        email
      });
      webchat.renderFrame({
        containerEl: "chat-container"
      });
      setHideForm(true);
    } catch (error) {
      if (process.env.NEXT_PUBLIC_VERCEL_ENV === "development") {
        console.error("Error starting chat");
        console.error(error);
      }
    }
  };

  useEffect(() => {
    if (document && window) {
      appendScript({
        src: "https://code.jquery.com/jquery-3.2.1.min.js",
        integrity: "sha256-hwg4gsxgFZhOsEEamdOYGBf13FyQuiTwlAQgxVSNgt4=",
        crossorigin: "anonymous"
      });
      appendScript({
        id: "purecloud-webchat-js",
        type: "text/javascript",
        src: "https://apps.mypurecloud.com/webchat/jsapi-v1.js",
        region: "ap-southeast-2",
        "org-guid": orgGuid,
        "deployment-key": deploymentId
      });
      window.PURECLOUD_WEBCHAT_FRAME_CONFIG = {
        containerEl: "chat-container"
      };
    }
  }, []);
  useEffect(() => {
    if (window && window.ININ) {
      window.ININ.webchat.create(chatConfig).then(webchat => {
        if (webchat.isAutoJoined()) {
          setHideForm(true);
          return;
        }

        setWebchat(webchat);
      }).catch(error => {
        if (process.env.NEXT_PUBLIC_VERCEL_ENV === "development") {
          console.error("Error initializing chat");
          console.error(error);
        }
      });
    }
  }, [window.ININ]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("form", {
      id: "chatForm",
      className: hideForm ? "hidden" : "p-6",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "mt-0",
        children: "Enter your details to start a chat"
      }), /*#__PURE__*/_jsxs("div", {
        className: "webchat-config",
        children: [/*#__PURE__*/_jsx(Input, _extends({
          type: "text"
        }, form.getInputProps("firstName"), {
          children: "First Name"
        })), /*#__PURE__*/_jsx(Input, _extends({
          type: "text"
        }, form.getInputProps("lastName"), {
          children: "Last Name"
        })), /*#__PURE__*/_jsx(Input, _extends({
          type: "email"
        }, form.getInputProps("email"), {
          children: "Email"
        }))]
      }), /*#__PURE__*/_jsx(Button, {
        onClick: startChat,
        className: "mt-5",
        color: "tertiary",
        children: "Start Chat"
      })]
    }), /*#__PURE__*/_jsx("div", {
      id: "chat-container"
    })]
  });
};
//# sourceMappingURL=purecloud_chat.js.map